import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useEventModal } from "@/hooks/useEventModal";
import { EventDetailSheet } from "@/components/EventDetailSheet";
import { CommandModal } from "@/components/CommandModal";
import {
  useCommandModalStore,
  selectCommandModalOpen,
  selectCommandAutoListen,
  selectOpenCommandModal,
  selectCloseCommandModal,
} from "@/stores";
import { useRememberVisit } from "@/hooks/useRememberVisit";
import { BottomTabBar } from "./BottomTabBar";

export function MobileShell() {
  const isMobile = useIsMobile();
  useRememberVisit();

  const { eventId, closeEvent } = useEventModal();
  const eventSheet = <EventDetailSheet eventId={eventId} onClose={closeEvent} />;

  const commandOpen = useCommandModalStore(selectCommandModalOpen);
  const autoListen = useCommandModalStore(selectCommandAutoListen);
  const openCommand = useCommandModalStore(selectOpenCommandModal);
  const closeCommand = useCommandModalStore(selectCloseCommandModal);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.code === "KeyK") {
        event.preventDefault();
        openCommand();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [openCommand]);

  const commandPalette = (
    <CommandModal open={commandOpen} onClose={closeCommand} autoListen={autoListen} />
  );

  if (!isMobile) {
    return (
      <div className="h-dvh w-full">
        <Outlet />
        {eventSheet}
        {commandPalette}
      </div>
    );
  }

  return (
    <div className="flex h-dvh flex-col bg-[var(--surface-sunken)]">
      <div className="min-h-0 flex-1 overflow-y-auto">
        <Outlet />
      </div>
      <BottomTabBar />
      {eventSheet}
      {commandPalette}
    </div>
  );
}
